import { Component, OnInit, OnDestroy } from "@angular/core";
import { IndicatorsService } from "../../services/indicators.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-indicators",
  templateUrl: "./indicators.component.html",
  styleUrls: ["./indicators.component.scss"],
})
export class IndicatorsComponent implements OnInit, OnDestroy {
  loadingInterstitialParams: any;
  alertParams: any;

  private sGetLoadingInterstitialState: Subscription;
  private sGetAlertState: Subscription;

  constructor(private indicatorsService: IndicatorsService) {}

  ngOnInit() {
    this.sGetLoadingInterstitialState = this.indicatorsService
      .getLoadingInterstitial()
      .subscribe((params) => {
        this.loadingInterstitialParams = params;
      });

    this.sGetAlertState = this.indicatorsService
      .getAlert()
      .subscribe((params) => {
        this.alertParams = params;
      });
  }

  ngOnDestroy(): void {
    this.sGetLoadingInterstitialState.unsubscribe();
    this.sGetAlertState.unsubscribe();
  }
}
